<template>
  <div class="raport-generate-progress-container">
    <div class="raport-generate-progress">
      <el-progress
        :percentage="progressPercentage"
        :stroke-width="16"
        color="#ad466c"
      ></el-progress>
      <div v-if="selectedEmployee">
        <small>Generating a report for {{ selectedEmployee.name }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progressComponent',
  props: ['allEmployeesCounter', 'totalEmployees', 'selectedEmployee'],
  data() {
    return {
      progressPercentage: 0
    };
  },
  watch: {
    allEmployeesCounter(newVal, oldVal) {
      this.progressPercentage = this.calculateProgress(
        newVal,
        this.totalEmployees
      );
      if (this.progressPercentage >= 100) {
        this.$emit('progress-complete');
      }
    }
  },
  methods: {
    resetProgress() {
      this.progressPercentage = 0;
    },
    calculateProgress(counter, total) {
      return Math.min(100, Math.max(0, Math.round((counter / total) * 100)));
    }
  }
};
</script>

<style>
.raport-generate-progress-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.7);
}

.raport-generate-progress {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
}

.el-progress-bar__inner {
  transition: width 0.3s ease;
}
</style>
